import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LoginPage = () => {
  const [isLogin, setIsLogin] = useState(true); // Přepínání Login / Registrace

  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <div style={{ backgroundColor: '#f4e9dc', minHeight: '100vh', paddingTop: '140px', paddingBottom: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <motion.div 
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
        style={{ 
          background: '#fff', 
          padding: '40px', 
          borderRadius: '20px', 
          boxShadow: '0 15px 35px rgba(0,0,0,0.1)', 
          width: '100%', 
          maxWidth: '450px',
          textAlign: 'center'
        }}
      >
        <AnimatePresence mode="wait">
          {isLogin ? (
            <motion.div
              key="login"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
            >
              <h2 style={{ marginBottom: '10px', color: '#2b1f18' }}>Vítejte zpět</h2>
              <p style={{ color: '#666', marginBottom: '30px' }}>Přihlaste se ke svému řezbářskému účtu</p>
              
              <form style={formStyle}>
                <input type="email" placeholder="Email" style={inputStyle} required />
                <input type="password" placeholder="Heslo" style={inputStyle} required />
                <motion.button 
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="contact-button" 
                  style={{ width: '100%', marginTop: '10px' }}
                >
                  Přihlásit se
                </motion.button>
              </form>
            </motion.div>
          ) : (
            <motion.div
              key="register"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
            >
              <h2 style={{ marginBottom: '10px', color: '#2b1f18' }}>Vytvořit účet</h2>
              <p style={{ color: '#666', marginBottom: '30px' }}>Staňte se součástí komunity a sledujte aukce</p>
              
              <form style={formStyle}>
                <input type="text" placeholder="Celé jméno" style={inputStyle} required />
                <input type="email" placeholder="Email" style={inputStyle} required />
                <input type="password" placeholder="Heslo znovu" style={inputStyle} required />
                <motion.button 
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="contact-button" 
                  style={{ width: '100%', marginTop: '10px', background: '#2b1f18' }}
                >
                  Zaregistrovat se
                </motion.button>
              </form>
            </motion.div>
          )}
        </AnimatePresence>

        <div style={{ marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
          <p style={{ fontSize: '0.9rem', color: '#666' }}>
            {isLogin ? "Ještě nemáte účet?" : "Již máte účet?"}
            <span 
              onClick={() => setIsLogin(!isLogin)} 
              style={{ color: '#8b5a2b', fontWeight: 'bold', cursor: 'pointer', marginLeft: '8px' }}
            >
              {isLogin ? "Zaregistrujte se" : "Přihlaste se"}
            </span>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

// --- STYLY ---
const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px'
};

const inputStyle = {
  padding: '12px 15px',
  borderRadius: '8px',
  border: '1px solid #ddd',
  fontSize: '1rem',
  outlineColor: '#d1b892',
  backgroundColor: '#fafafa'
};

export default LoginPage;